<template>
  <AccordionButton title="Open Basket" :on-click="openBasket" :disabled="disabled"/>
</template>

<script setup>
  import { computed } from "vue";
  import router from "@/router/index.js";
  import AccordionButton from "@/components/search-page/basket-action-drawer/AccordionButton.vue";
  import { storeToRefs } from "pinia";
  import { useCabinetStore } from "@/stores/cabinetStore.js";
  import { useSearchPageStore } from "@/stores/searchPageStore.js";

  const cabinetStore = useCabinetStore()
  const { cabinetId } = storeToRefs(cabinetStore)

  const searchPageStore = useSearchPageStore()
  const { basketCount } = storeToRefs(searchPageStore)

  const disabled = computed(() => basketCount.value <= 0)

  const openBasket = async () => {
    const basketId = await searchPageStore.generateBasket()
    const routeData = router.resolve({
      name: 'basketViewer',
      params: {
        cabinetId: cabinetId.value,
        basketId: basketId,
        basketIndex: 0
      }
    })
    window.open(routeData.fullPath, '_blank')
  }
</script>

<style scoped lang="scss">

</style>
